import ServiceBase from "@app/shared/serviceBase";
import {
  AccessPointProcessingGroup,
  AccessPointProcessingResult,
} from "../models";
import { ImportSagaState } from "../state";

export default class ProviderNetworkImportService extends ServiceBase {
  public async getLatestProcessingResults(versionId: number): Promise<AccessPointProcessingResult[]> {
    return await this.makeGet<AccessPointProcessingResult[]>(`/upload/results?versionId=${versionId}`, null, window.qesiProviderNetworkApi);
  }

  public async runGroups(groups: AccessPointProcessingGroup[], versionId: number): Promise<void> {
    return await this.makePost(`upload/version/${versionId}/run`, groups, window.qesiProviderNetworkApi);
  }

  public async getImportState(versionId: number): Promise<ImportSagaState> {
    return await this.makeGet(`upload/version/${versionId}/state`, null, window.qesiProviderNetworkApi);
  }

  public async getExportResults(versionId: number): Promise<string> {
    const headers = await this.headers();
    let token: string = headers.Authorization;
    if (token.startsWith("Bearer ")) { token = token.split(" ")[1]; }
    return window.qesiProviderNetworkApi.concat(`/upload/export?versionId=${versionId}&access_token=${token}`);
  }
}
